import _ from 'lodash';
import { useState } from "react";
import { FloatingTextInput } from "../reusable-elements/floating-text-input";
import { notNullOrEmpty, isValidTime } from "../../utils/validators";

export const Schedule = ({ schedule, counter, onChange }) => {

    const [weekdaysChecked, setWeekdaysChecked] = useState(false);
    const [weekendsChecked, setWeekendsChecked] = useState(false);
    const [rerender, setRerender] = useState(false);

    const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const weekendDays = [5, 6];
    const weekDays = [0, 1, 2, 3, 4]

    const handleCheckWeekdays = selected => {

        setWeekdaysChecked(selected);
        setWeekendsChecked(false);

        if (selected) {
            schedule.days = weekDays;
        }
        else {
            schedule.days = schedule.days.filter(day => !weekDays.includes(day));
        }

        schedule.days = _.orderBy(schedule.days, [], ['asc']);

        onChange(schedule);
        setRerender(!rerender);
    };

    const handleCheckWeekends = selected => {

        setWeekendsChecked(selected);
        setWeekdaysChecked(false);

        if (selected) {
            schedule.days = weekendDays;
        }
        else {
            schedule.days = schedule.days.filter(day => !weekendDays.includes(day));
        }

        schedule.days = _.orderBy(schedule.days, [], ['asc']);
        onChange(schedule);
        setRerender(!rerender);
    };

    const getDayOfWeek = index => daysOfWeek[index];
    const getIndexOfDay = day => daysOfWeek.indexOf(day);

    const toggleDaySelected = dayIndex => {

        if (schedule.days.includes(dayIndex)) {
            schedule.days = schedule.days.filter(d => d !== dayIndex);
        } else {
            schedule.days.push(dayIndex);
        }
        setRerender(!rerender);
        onChange(schedule);
    };

    const isDaySelected = dayIndex => schedule.days.includes(dayIndex);

    const day = (name, selected) => {
        return (
            <div key={`dayname-${name}`} className="form-check form-check-inline" style={{ width: "25%" }}>
                <input className="form-check-input" type="checkbox" id={`${name}-checkbox`} checked={selected} onChange={() => toggleDaySelected(getIndexOfDay(name))} />
                <label className="form-check-label" htmlFor={`${name}-checkbox`}>{name}</label>
            </div>
        );
    };

    return !!schedule && (

        <div className="input-group mb-3">
            <div className="input-group mb-2">Schedule #{counter + 1}</div>

            <div className="form-check form-check-inline form-switch">
                <input className="form-check-input" type="checkbox" id="checkbox1" checked={weekdaysChecked} onChange={e => handleCheckWeekdays(e.target.checked)} />
                <label className="form-check-label" htmlFor="checkbox1">Weekdays</label>
            </div>
            <div className="form-check form-check-inline form-switch">
                <input className="form-check-input" type="checkbox" id="checkbox1" checked={weekendsChecked} onChange={e => handleCheckWeekends(e.target.checked)} />
                <label className="form-check-label" htmlFor="checkbox1">Weekends</label>
            </div>

            <div className="input-group mt-3">
                {daysOfWeek.map((_, i) => day(getDayOfWeek(i), isDaySelected(i)))}
            </div>
            <div className="input-group mt-3">
                <FloatingTextInput
                    className={""}
                    label={"Start (hh:mm:ss)"}
                    text={schedule.start}
                    updateCallback={newValue => { onChange({ ...schedule, start: newValue }); }}
                    validatorFn={() => { return notNullOrEmpty(schedule.start) && isValidTime(schedule.start); }}
                    readOnly={false}
                />
                <FloatingTextInput
                    className={""}
                    label={"End (hh:mm:ss)"}
                    text={schedule.end}
                    updateCallback={newValue => { onChange({ ...schedule, end: newValue }); }}
                    validatorFn={() => { return notNullOrEmpty(schedule.end) && isValidTime(schedule.end); }}
                    readOnly={false}
                />
            </div>
        </div>

    );

};